const topicsData = [
  { label: '#长相思第二季', heat: '985万' },
  { label: '#玫瑰的故事', heat: '872万' },
  { label: '#你比星光美丽', heat: '836万' },
  { label: '#庆余年第二季', heat: '791万' },
  { label: '#墨雨云间', heat: '754万' },
  { label: '#狐妖小红娘', heat: '718万' },
  { label: '#古装剧推荐', heat: '652万' },
  { label: '#高分韩剧', heat: '589万' },
  { label: '#暑假追剧', heat: '534万' },
  { label: '#悬疑推理', heat: '487万' },
  { label: '#甜宠爱情', heat: '421万' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">追剧圈正在热议的话题与标签，看看大家都在聊什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => {
            const colors = [
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-50 text-primary-600 hover:bg-primary-100',
              'bg-accent-50 text-accent-600 hover:bg-accent-100',
              'bg-secondary-50 text-secondary-600 hover:bg-secondary-100',
              'bg-primary-50 text-primary-600 hover:bg-primary-100',
              'bg-accent-50 text-accent-600 hover:bg-accent-100',
            ];
            return (
              <span
                key={i}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${colors[i]}`}
              >
                {topic.label}
                <span className="text-xs opacity-60">{topic.heat}</span>
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}